export const encyclopediaRu = {
  // Общие
  'encyclopedia.lockAria': 'Заперто — разблокируй для чтения',

  // EncyclopediaPage
  'encyclopedia.page.seoTitle': 'Энциклопедия',
  'encyclopedia.page.seoDescription':
    'Откройте живой гримуар Grymwyrd — чудовищ, заклинаний, расы, предметы, места и многое другое.',
  'encyclopedia.page.heading': 'Энциклопедия',
  'encyclopedia.page.subtitle': 'Живой гримуар всех ужасов, заклинаний и легенд в Grymwyrd.',
  'encyclopedia.page.searchPlaceholder': 'Поиск {plural}…',
  'encyclopedia.page.searchAria': 'Поиск {plural}',
  'encyclopedia.page.clearSearch': 'Очистить поиск',
  'encyclopedia.page.systemNotLivePrefix': 'Завеса ещё не приподнялась для',
  'encyclopedia.page.systemNotLiveSuffix':
    '. Никакая магия, связанная с этим ритуалом, не просочилась — её гримуар ждёт за тьмой.',
  'encyclopedia.page.returnToAllSystems': 'Вернуться ко всем системам',
  'encyclopedia.page.settingNotLivePrefix': 'Земли',
  'encyclopedia.page.settingNotLiveSuffix':
    ' ещё картографируются — их записи ещё не привязаны к миру. Пока картографы не закончат, ничего не отвечает здесь.',
  'encyclopedia.page.returnToAllRealms': 'Вернуться ко всем мирам',
  'encyclopedia.page.filteringBy': 'Фильтр по',
  'encyclopedia.page.filterSystem': 'система "{label}"',
  'encyclopedia.page.filterCanon': 'канонический уровень "{label}"',
  'encyclopedia.page.filterSetting': 'мир "{label}"',
  'encyclopedia.page.canonNote': 'Канонический уровень действует после разметки сущностей в API (см. _docs/13). ',
  'encyclopedia.page.clear': 'Очистить',
  'encyclopedia.page.hide': 'Скрыть',
  'encyclopedia.page.filter': 'Фильтр',

  // EntityCard
  'encyclopedia.entityCard.unlockAria': 'Разблокировать {name} (контент Grymwyrd)',
  'encyclopedia.entityCard.viewAria': 'Показать запись {name}',

  // EntityGrid
  'encyclopedia.grid.paginationAria': 'Навигация ({position})',
  'encyclopedia.grid.prev': 'Назад',
  'encyclopedia.grid.next': 'Вперёд',
  'encyclopedia.grid.pageOf': 'Страница {page} из {totalPages}',
  'encyclopedia.grid.resultsAria': '{plural} результатов',
  'encyclopedia.grid.scrying': 'Вскрытие архивов…',
  'encyclopedia.grid.count': '{total} {plural}',
  'encyclopedia.grid.sortDescAria': 'Сортировать по убыванию',
  'encyclopedia.grid.sortAscAria': 'Сортировать по возрастанию',
  'encyclopedia.grid.sortAZ': 'А–Я',
  'encyclopedia.grid.sortZA': 'Я–А',
  'encyclopedia.grid.viewModeAria': 'Режим просмотра',
  'encyclopedia.grid.gridViewAria': 'Сеточный вид',
  'encyclopedia.grid.listViewAria': 'Список',
  'encyclopedia.grid.jumpToLetterAria': 'Перейти к букве',
  'encyclopedia.grid.all': 'Все',
  'encyclopedia.grid.letterSymbolAria': 'Записи, начинающиеся с цифры или символа',
  'encyclopedia.grid.letterAria': 'Записи, начинающиеся с {letter}',
  'encyclopedia.grid.emptyTitle': 'Архив молчит',
  'encyclopedia.grid.emptyForLetter': 'Нет {plural}, чьё имя начинается с "{letter}".',
  'encyclopedia.grid.emptyAll': 'Ни {plural} не отвечают на твой зов.',
  'encyclopedia.grid.turningPages': 'Листаем страницы…',

  // EntityImage
  'encyclopedia.entityImage.noArtworkAria': '{label} (нет изображения)',
  'encyclopedia.entityImage.noVision': 'Нет видения',

  // FacetSidebar
  'encyclopedia.facets.all': 'Все',
  'encyclopedia.facets.soon': 'Скоро',
  'encyclopedia.facets.navAria': 'Фильтры по типу сущности',
  'encyclopedia.facets.clearAll': 'Очистить все фильтры',
  'encyclopedia.facets.lorebook': 'Книга легенд',
  'encyclopedia.facets.gameSystem': 'Игровая система',
  'encyclopedia.facets.canonLayer': 'Канонический уровень',
  'encyclopedia.facets.setting': 'Мир',

  // GlobalSearch
  'encyclopedia.globalSearch.title': 'Поиск сквозь Завесу',
  'encyclopedia.globalSearch.placeholder': 'Поиск чудовищ, заклинаний, мест, легенд…',
  'encyclopedia.globalSearch.queryAria': 'Поисковый запрос',
  'encyclopedia.globalSearch.loading': 'Вскрытие…',
  'encyclopedia.globalSearch.empty': 'Ничего не шевелится в тьме по "{q}".',

  // LockedContent — LockBadge
  'encyclopedia.lockBadge.title': 'Контент Grymwyrd — разблокируй для чтения',
  'encyclopedia.lockBadge.label': 'Заперто',
  // LockedContent — LockedGate
  'encyclopedia.lockedGate.regionAria': 'Закрытый контент',
  'encyclopedia.lockedGate.defaultTitle': 'Эта магия запечатана',
  'encyclopedia.lockedGate.body':
    'Собственный бестиарий Grymwyrd, заклинания и легенды связаны с Катаклизмом Grymwyrd. Открытый канон SRD остаётся свободным — но чтобы ступить в вечные сумерки, обладай книгой.',
  'encyclopedia.lockedGate.unlockCta': 'Разблокировать Grymwyrd',
  'encyclopedia.lockedGate.signInCta': 'Уже спонсор? Войти',
  'encyclopedia.lockedGate.backerNote':
    'Спонсоры, поддержавшие Grymwyrd, уже владеют этим — войди на свой аккаунт, чтобы разблокировать.',

  // TableView
  'encyclopedia.table.rollToastTitle': '{name} — выпало {total}',
  'encyclopedia.table.noRowMatched': 'Ни одна строка не соответствует {total}.',
  'encyclopedia.table.loading': 'Разворачиваем таблицу…',
  'encyclopedia.table.error': 'Эту таблицу не удалось отрисовать.',
  'encyclopedia.table.roll': 'Бросить {formula}',
  'encyclopedia.table.lastRoll': 'Последний бросок: {value}',
  'encyclopedia.table.noMatchingRow': ' · нет подходящей строки',

  // EntityDetailPage
  'encyclopedia.detail.entryFallback': 'Запись',
  'encyclopedia.detail.addedToCampaign': 'Добавлено в твой кампанию.',
  'encyclopedia.detail.addError': 'Не удаётся связаться с хранилищем кампании. Попытайся позже.',
  'encyclopedia.detail.unknownType': 'Неизвестный тип записи.',
  'encyclopedia.detail.seoDescription': '{name} — {label} в Энциклопедии Grymwyrd.',
  'encyclopedia.detail.breadcrumbAria': 'Навигационная цепь',
  'encyclopedia.detail.breadcrumbRoot': 'Энциклопедия',
  'encyclopedia.detail.sourceVersionAria': 'Версия источника',
  'encyclopedia.detail.versionConsolidated': 'Консолидированная',
  'encyclopedia.detail.versionBook': 'Издание книги',
  'encyclopedia.detail.removeBookmarkAria': 'Удалить закладку',
  'encyclopedia.detail.addBookmarkAria': 'Добавить закладку',
  'encyclopedia.detail.bookmarked': 'В закладках',
  'encyclopedia.detail.bookmark': 'Закладка',
  'encyclopedia.detail.addToCampaign': 'Добавить в кампанию',
  'encyclopedia.detail.sealedTitle': '{name} запечатана',
  'encyclopedia.detail.bookVariantNote':
    'Показываем консолидированную запись; текст для каждого издания появится здесь, как только издания будут привязаны.',
  'encyclopedia.detail.tablistAria': 'Разделы записи',
  'encyclopedia.detail.tab.lore': 'Легенды',
  'encyclopedia.detail.tab.stats': 'Характеристики',
  'encyclopedia.detail.tab.gallery': 'Галерея',
  'encyclopedia.detail.tab.relations': 'Связи',
  'encyclopedia.detail.tab.discussions': 'Обсуждения',
  'encyclopedia.detail.tab.claims': 'Утверждения игроков',
  'encyclopedia.detail.loading': 'Пробуждаем запись…',

  // tabs/LoreTab
  'encyclopedia.lore.loading': 'Извлекаем магию…',
  'encyclopedia.lore.empty': 'История этой записи остаётся неписаной.',

  // tabs/StatsTab
  'encyclopedia.stats.loading': 'Читаем руны…',
  'encyclopedia.stats.empty': 'Никакие механики не записаны для этой записи.',

  // tabs/GalleryTab
  'encyclopedia.gallery.loading': 'Проявляем видения…',
  'encyclopedia.gallery.emptyTitle': 'Видений нет',
  'encyclopedia.gallery.emptyBody': 'К этой записи не привязано никакого изображения. Добавь его в Хранилище.',
  'encyclopedia.gallery.artworkAlt': 'Изображение сущности',

  // tabs/DiscussionsTab
  'encyclopedia.discussions.loading': 'Собираем шёпоты…',
  'encyclopedia.discussions.emptyTitle': 'Тишина в залах',
  'encyclopedia.discussions.emptyBody': 'Будь первым, кто обсудит эту запись с товарищами путников.',
  'encyclopedia.discussions.startCta': 'Начать обсуждение',
  'encyclopedia.discussions.untitledThread': 'Безымянная тема',
  'encyclopedia.discussions.byAuthor': '{author}',
  'encyclopedia.discussions.replyCount': '{count} ответов',

  // tabs/ClaimsTab
  'encyclopedia.claims.recorded': 'Твоё утверждение записано на рассмотрение.',
  'encyclopedia.claims.recordError': 'Писцы не смогли записать твоё утверждение. Попытайся позже.',
  'encyclopedia.claims.loading': 'Консультируемся с каноном…',
  'encyclopedia.claims.emptyTitle': 'Утверждений игроков нет',
  'encyclopedia.claims.emptyBody': 'Ни один путник ещё не вплёл свою легенду в эту запись.',
  'encyclopedia.claims.claimCta': 'Заявить о праве',
  'encyclopedia.claims.signInCta': 'Войди, чтобы заявить о праве',
  'encyclopedia.claims.untitledClaim': 'Безымянное утверждение',
  'encyclopedia.claims.byAuthor': '{author}',
  'encyclopedia.claims.addCta': 'Добавить своё утверждение',

  // tabs/RelationsTab
  'encyclopedia.relations.thisEntry': 'Эта запись',
  'encyclopedia.relations.relationLabel': 'Связь {index}',
  'encyclopedia.relations.kindredLabel': 'Родственник {index}',
  'encyclopedia.relations.loading': 'Прослеживаем нити судьбы…',
  'encyclopedia.relations.hintIntro': 'Нажми на узел, чтобы перейти к этой записи. Показаны нити',
  'encyclopedia.relations.hintCanonical': ' канонических связей.',
  'encyclopedia.relations.hintKindred': ' родственные записи того же типа.',
}
